import { render, staticRenderFns } from "./Pausa.vue?vue&type=template&id=337aca00&"
import script from "./Pausa.vue?vue&type=script&lang=js&"
export * from "./Pausa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports